<template>
    <v-container>

        <Titulo></Titulo>

        <div class="text-center">
            <br v-if="screen < 800">
            <br v-if="screen < 800">
            <v-img contain max-height="115" :src="ErrorImageMobile" max-width="115" style="margin:auto;" />

            <br><br>

            <h4 :class="errorTitle">Hubo un problema con tu pago</h4>
            
            <br v-if="screen < 800">

            <h4 :class="errorSubtitle">Parece que la transacción no pudo completarse, pero no te preocupes que debe ser temporal.</h4>

        </div>

        <br>
        <br>

        <div class="text-center">
            <h4 :class="errorTitle">Te invitamos a:</h4>
        </div>

        <br>

        <div class="text-center">
            <h4 :class="errorSubtitle" style="margin-bottom: 4%;">Volver a la página de inicio</h4>
            <v-btn :class="btnContinue" elevation="0" @click="returnPage()">
                <v-icon color="white" dark left>
                    mdi-arrow-left
                </v-icon>
                VOLVER AL INICIO
            </v-btn>
            <br>
            <br>
            <!-- <h4 :class="errorSubtitle" style="margin-bottom: 4%;">Solicitar asistencia</h4>
            <v-btn :class="btnCustomerService" elevation="0"
                @click="returnPage()">
                <v-img contain max-height="25" :src="customerServiceIcon" max-width="25" style="margin-right: 3%;" />
                ATENCIÓN AL CLIENTE
            </v-btn> -->
            <br>
            
        </div>

    </v-container>
</template>

<script>
import ErrorImage from "@/assets/images/Error.png";
import ErrorImageMobile from "@/assets/images/ErrorIconMobile.svg";
import customerServiceIcon from "@/assets/images/customerServiceIcon.svg";
import Titulo from "../components/Titulo.vue";

export default {
    components: { Titulo },
    data() {
        return {
            secretKey: process.env.VUE_APP_CRYPT,
            userData: {
                name: null,
                surname: null,
                serialNumber: null,
                rut: null,
                typeIsapre: null,
                region: null,
                commune: null,
                comuneCode: null,
                regionCode: null,
                address: null,
                email: null,
                phoneNumber: null,
                couponId: null,
                stepId: null,
                old: null,
                dates: null,
                salud: null,
                questionOne: null,
                questionTwo: null,
                questionThree: null,
                typePlan: null,
                addressNumber: null,
                addressDepto: null,
                sonExist: false,
                arrayTypesBenef: [],
                oldAux: null,
                day: null,
                month: null,
                year: null,
            },
            image: null,
            errorTitle: null,
            errorSubtitle: null,
            btnContinue: null,
            btnCustomerService: null,
            ErrorImage,
            ErrorImageMobile,
            customerServiceIcon,
            screen: window.screen.width,
            idIsurance: null,
        }
    },
    async mounted() {

        const query = this.$route.query;
        const idIsurance = query.id;

        if(idIsurance) {
            this.idIsurance = idIsurance;
        }

        if (this.screen > 800) {
            this.image = 'image';
            this.errorTitle = 'errorTitle';
            this.errorSubtitle = 'errorSubtitle';
            this.btnContinue = 'btnContinue';
            this.btnCustomerService = 'btnCustomerService';
        } else {
            this.image = 'image2';
            this.errorTitle = 'errorTitle2';
            this.errorSubtitle = 'errorSubtitle2';
            this.btnContinue = 'btnContinue2';
            this.btnCustomerService = 'btnCustomerService2';
        }
    },
    methods: {
        returnPage() {
            const url = `${window.location.origin}/og/recovery?id=${this.idIsurance}`;
            window.location.href = url;
        },
    }

}
</script>

<style lang="css" scoped>
.btnCustomerService{
    padding: 12px 15px; 
    gap: 10px; 
    width: 345px; 
    height: 50px !important; 
    background: #2D387C !important; 
    box-shadow: 4px 8px 24px rgba(51, 51, 204, 0.12);
    border-radius: 12px; 
    text-transform:inherit; 
    color: white;
}
.btnCustomerService2{
    padding: 12px 15px; 
    gap: 10px; 
    width: 280px; 
    height: 50px !important; 
    background: #2D387C !important; 
    box-shadow: 4px 8px 24px rgba(51, 51, 204, 0.12);
    border-radius: 12px; 
    text-transform:inherit; 
    color: white;
}
.btnContinue{
    padding: 12px 15px; 
    gap: 10px; 
    width: 345px; 
    height: 50px !important; 
    background: #4F74E3; 
    box-shadow: 4px 8px 24px rgba(51, 51, 204, 0.12);
    border-radius: 12px; 
    text-transform:inherit; 
    color: white;
}
.btnContinue2{
    padding: 12px 15px; 
    gap: 10px; 
    width: 280px; 
    height: 50px !important; 
    background: #4F74E3; 
    box-shadow: 4px 8px 24px rgba(51, 51, 204, 0.12);
    border-radius: 12px; 
    text-transform:inherit; 
    color: white;
}
.errorSubtitle{
    font-family: Poppins; 
    font-style: normal; 
    font-weight: 400; 
    font-size: 20px; 
    line-height: 25px; 
    letter-spacing: -0.01em;
    color: #232323;
}
.errorSubtitle2{
    font-family: Poppins; 
    font-style: normal; 
    font-weight: 400; 
    font-size: 14px; 
    line-height: 24px; 
    letter-spacing: -0.01em;
    color: #232323;
    width: 72%;
    margin: auto;
}
.errorTitle{
    font-family: Poppins; 
    font-style: normal; 
    font-weight: 600; 
    font-size: 20px; 
    line-height: 25px; 
    letter-spacing: -0.01em;
    color: #2D387C;
}
.errorTitle2{
    font-family: Poppins; 
    font-style: normal; 
    font-weight: 600; 
    font-size: 18px; 
    line-height: 28px; 
    letter-spacing: -0.01em;
    color: #2D387C;
    width: 50%;
    margin: auto;
}
.v-alert {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%, 100%);
    margin: 0 auto;
}

.image {
    width: 20%;
    margin: auto;
}

.image2 {
    width: 100%;
    margin: auto;
}
</style>
